import comp from "./LoadingV2";
export default comp;
